import ApiService from './ApiService';
import axios from 'axios';
import { PoliciesPermissionSetItems } from 'common/constants/permissions';

export default class PermissionsService extends ApiService {
  public getPermissions = (): Promise<PoliciesPermissionSetItems[]> => {
    return axios.get('/api/v1/security/policy/permissions');
  };
}
